'use client';

import { prospectsApiResponse, uploadProspectFileResponse } from '@repo/prospects-api';
import { getClientCookie } from '@repo/utils';

type apiResponse = uploadProspectFileResponse &
  prospectsApiResponse & {
    softError?: boolean;
    hardError?: boolean;
    message?: string;
    status?: string;
    notAuth?: boolean;
  };

export const uploadProspectFileClient: (args: { prospectId: string; data: FormData }) => Promise<apiResponse> = async ({
  prospectId,
  data,
}: {
  prospectId: string;
  data: FormData;
}) => {
  const token = getClientCookie('token-backoffice');
  const baseUrl = process.env.NEXT_PUBLIC_BACKOFFICE_API_ROUTE || '';
  const url = `${baseUrl}prospects/${prospectId}/documents`;
  try {
    const response = await fetch(url, {
      method: 'POST',
      body: data,
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });

    if (response.status === 401 || response.status === 403) {
      return Promise.resolve({ notAuth: true, status: response.status });
    }

    const parsed = await response.json();
    if (!response.ok) {
      parsed.softError = true;
      parsed.hardError = !parsed.status || parsed.status.toString().charAt(0) === '5';
    }
    return parsed;
  } catch (error) {
    console.error('Error uploading prospect file:', error);
    throw error;
  }
};
